// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_68b5527","city":"_1216721"};